// extracted by mini-css-extract-plugin
module.exports = {"home-button":"HomeButton_home-button__s8115","home-button__logo":"HomeButton_home-button__logo__2RXSX","home-button__logo-small":"HomeButton_home-button__logo-small__1x_Bt"};